/**
 * Auth module Zod schemas.
 * See docs/product/backend/m01-identity-auth-rbac.md.
 */

import { z } from 'zod';
import { IndianPhoneSchema } from './common';

export const VerifyTokenInputSchema = z.object({
  idToken: z.string().min(10),
});

export const RequestOtpInputSchema = z.object({
  phoneNumber: IndianPhoneSchema,
});

export const VerifyOtpInputSchema = z.object({
  phoneNumber: IndianPhoneSchema,
  otp: z.string().regex(/^\d{4,6}$/, 'must be 4-6 digits'),
  otpRefId: z.string().optional(),
});

export type VerifyTokenInput = z.infer<typeof VerifyTokenInputSchema>;
export type RequestOtpInput = z.infer<typeof RequestOtpInputSchema>;
export type VerifyOtpInput = z.infer<typeof VerifyOtpInputSchema>;
